module.exports = function () {

	$(document).on({
		click: function(e) {
			e.preventDefault();

			var link = url($(this).data('href'));

			window.location.assign(link);
		}
	}, '[data-href]');

}
